exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_birthdayContainer_2l3ZfRf8UzuLfr_nsfC_CS{\n  width: 100%;\n  display: inline-block;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_birthdayContainer": "IA_birthdayContainer_2l3ZfRf8UzuLfr_nsfC_CS"
};